<template>
  <b-modal v-model="$show" centered hide-footer title="Submit full evidence">
    <div class="modal-body-content">
      <p class="custome-text-muted mb-3">
        The full evidence is incomplete.<br />
        Please complete the following parts
      </p>

      <div class="incomplete-parts-container">
        <div v-for="(part, index) in incompleteParts" :key="index" class="incomplete-part-item">
          {{ part.part }}
        </div>
      </div>

      <p class="custome-text-muted mt-3 mb-3">
        Ensure your full evidence is complete and ready for submission.
      </p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalIncompleteEvidence',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    incompleteParts: {
      type: Array,
      default: () => ['Part 1 : Overview', 'Part 2 : Work Examples', 'Part 3 : Reflection']
    }
  },
  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-body-content {
  padding: 0;
}

.custome-text-muted {
  color: #7a7b97;
  font-size: 16px;
  line-height: 1.5;
}

.incomplete-parts-container {
  background-color: #fed6da;
  border-radius: 10.4px;
  padding: 12px 20px;
  margin: 16px 0;
  border: 1px solid #fdc6cb;
}

.incomplete-part-item {
  color: #841e30;
  font-size: 16px;
  font-weight: 700;
  // padding: 4px 0;
  font-style: bold;

  // &:not(:last-child) {
  //   margin-bottom: 4px;
  // }
}

::v-deep .modal-header {
  border-bottom: 1px solid #dee2e6;
  padding: 16px;

  .modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  .close {
    background-color: transparent;
    border: 0;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    opacity: 0.5;

    &:hover {
      opacity: 0.75;
    }
  }
}

::v-deep .modal-body {
  padding: 16px;
}
</style>
